import CaptchaModel from "../model/captcha.js";
import CaptchaModalPresenter from "../presenter/modal.js";

import {
  setCookie
} from "../../../utils/set-cookie.js";

import {
  getCookie
} from "../../../utils/get-cookie.js";

import {
  deleteCookie
} from "../../../utils/delete-cookie.js";

import {
  defaultCaptchaModelData,
  ActionType
} from "../const.js";

export default class Captcha {
  constructor() {
    this._model = null;
    this._modalPresenter = null;

    this._handleModelChange = this._handleModelChange.bind(this);
  }

  init() {
    const checkBot = getCookie(`check_bot`);

    if (!checkBot) {
      this._runForHuman();
      return;
    }

    this._model = new CaptchaModel(
        Object.assign(
            {},
            defaultCaptchaModelData
        )
    );
    this._model.addObserver(this._handleModelChange);
    this._checkUser();
  }

  _checkUser() {
    const isHuman = getCookie(`is_human`);

    if (
      isHuman &&
      isHuman === `true`
    ) {
      this._runForHuman();
      return;
    }

    const modelData = this._model.getData();

    if (modelData.passed === true) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        modelData,
        {
          modalRendered: true
        }
    ), ActionType.RENDER_MODAL);
  }

  _runForHuman() {
    if (!window.runForHuman) {
      return;
    }

    window.runForHuman.forEach((callback) => callback());
  }

  _processRenderModal() {
    this._modalPresenter = new CaptchaModalPresenter();
    this._modalPresenter.build();
    this._modalPresenter.setMasterModel(this._model);
  }

  _processDestroyModal() {
    this._modalPresenter.closeModal(this._modalPresenter.getInstance());

    let date = new Date(Date.now() + 31536000e3);
    date = date.toUTCString();

    setCookie(`is_human`, `true`, {
      expires: date
    }, true);
    deleteCookie(`check_bot`, true);

    this._runForHuman();
  }

  _handleModelChange(action) {
    switch (action) {
      case ActionType.RENDER_MODAL:
        this._processRenderModal();
        break;
      case ActionType.DESTROY_MODAL:
        this._processDestroyModal();
        break;
    }
  }
}
